import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from './cn.js';
/** Decorative voice-activity badge. Live levels inherit --speaking-level (0–1). */
export function SpeakingIndicator({ animated = false, className, ...props }) {
    return (_jsxs("span", { ...props, "aria-hidden": "true", "data-slot": "speaking-indicator", "data-animated": animated ? 'true' : undefined, className: cn('sc-speaking-indicator', className), children: [_jsx("span", {}), _jsx("span", {}), _jsx("span", {})] }));
}
//# sourceMappingURL=speaking-indicator.js.map